module.exports = __webpack_public_path__ + "1af46d10b9c681217875b6b64b7aa9dc.svg";